import { useProcessorDataContext } from '../../../../contexts/processor-data.context';
import { AddCardProviderJustifi } from './add-card-provider-justifi';
import { AddCardProviderStripe } from './add-card-provider-stripe';

export const AddCardProvider = ({ children }: React.PropsWithChildren<object>) => {
  const { activeGateway } = useProcessorDataContext();

  return (
    <>
      {activeGateway === 'stripe' && <AddCardProviderStripe>{children}</AddCardProviderStripe>}
      {activeGateway === 'justifi' && <AddCardProviderJustifi>{children}</AddCardProviderJustifi>}
    </>
  );
};
